import { render, staticRenderFns } from "./CashSettlementsStatementsTable.vue?vue&type=template&id=3621382a&"
import script from "./CashSettlementsStatementsTable.vue?vue&type=script&lang=js&"
export * from "./CashSettlementsStatementsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports